import React from "react";
import {connect} from "react-redux";

import Bin from "./Bin";

import c from "../../etc/Const"

import NewModule from "./newmodule"

import Planitemmock from "./planitemmock"

const Toolbox = ({root, scenario}) => {

    let switm = {
        id: c.EDITOR,
        x: 3,
        y: 0,
        type: 'sw',
        ori: 'east',
        subtype: 'right'
    }

    let tkitm = {
        id: c.EDITOR,
        x: 5,
        y: 0,
        type: 'tk',
    }

    let sgitm = {
        id: c.EDITOR,
        x: 7,
        y: 0,
        type: 'sg',
        ori: 'east'
    }

    let fbitm = {
        id: c.EDITOR,
        x: 9,
        y: 0,
        type: 'fb'
    }

    let fbs = [];

    let bkitm = {
        id: c.EDITOR,
        x: 11,
        y: 0,
        type: 'bk'
    }

    function handleDrag(e) {
        e.preventDefault();
    }

    function handleDragOver(e) {
        e.preventDefault();
    }

    function handleDrop(e) {
        e.preventDefault();
    }

    /*
    <Sw key={switm.id+switm.name} item={switm} />
            <Tk key={tkitm.id+tkitm.name} item={tkitm} />
            <Sg key={sgitm.id+sgitm.name} item={sgitm} fbs={fbs} />
            <Fb key={fbitm.id+fbitm.name} item={fbitm} />
            <Bk key={bkitm.id+bkitm.name} item={bkitm} width={1} />
     */

    return(
        root.editmode?
        <>
            <Planitemmock type='sg' id={c.EDITOR}/>
            <Planitemmock type='sw' id={c.EDITOR}/>
            <Planitemmock type='tk' id={c.EDITOR}/>
            <Planitemmock type='bk' id={c.EDITOR}/>
            <Planitemmock type='fb' id={c.EDITOR}/>
            <NewModule id={c.EDITOR} scenario={scenario}/>
            <Bin/>
        </>:null
    )
}

/*

 */

function mapStateToProps(state, ownProps) {
    return state
}

const mapDispatchToProps = dispatch => {
    // the state will be modified on answer ...
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Toolbox)